import Products from 'merchandise-lib/constants/Product';
import { getFscPreferredTermKey, getFscSeatNameAndDescription } from 'pricing-pages-ui-components/fsc-configure/fscCatalogHelpers';
import { selectFscCreditPackPlanOption } from 'pricing-pages-ui-components/fsc-configure/fscCreditPacksHelpers';
import { buildFscOrderSummaryDetails, buildFscSkuQuantityCart } from 'pricing-pages-ui-components/fsc-configure/fscOrderDetailsHelpers';
import { isPublicPurchaseMotion } from 'purchase-motions-components/utils/purchaseMotionTypeGuards';
import { Screens } from '../../types/PublicNavItem';
import { TRACKING_SOURCES } from '../../utils/tracking';
export function buildFscPlanCart({
  seats,
  creditPackSelection
}) {
  const seatCart = buildFscSkuQuantityCart(seats);
  if (creditPackSelection.kind !== 'custom' || creditPackSelection.committedSkuQuantity <= 0) {
    return seatCart;
  }
  return [...seatCart, {
    productApiName: Products.HUBSPOT_CREDITS_COMMITTED,
    skuQuantity: creditPackSelection.committedSkuQuantity
  }];
}
export function buildFscOrderDetails({
  catalog,
  tier,
  cart,
  productPlanOptions,
  term,
  currencyCode
}) {
  var _cart$seats$, _option$purchaseMotio;
  const option = selectFscCreditPackPlanOption(productPlanOptions, cart.creditPackSelection);
  const primaryProductApiName = (_cart$seats$ = cart.seats[0]) === null || _cart$seats$ === void 0 ? void 0 : _cart$seats$.productApiName;
  if (!option || !primaryProductApiName) return null;
  const termKey = getFscPreferredTermKey(option.pricing.purchaseOptions, term);
  if (!termKey) return null;
  const {
    content,
    requestedProducts,
    paymentTerm,
    commitmentTerm
  } = buildFscOrderSummaryDetails({
    catalog,
    tier,
    currencyCode,
    mode: 'purchase',
    seats: cart.seats,
    getSeatName: productApiName => getFscSeatNameAndDescription(catalog, productApiName).name,
    option,
    purchaseOption: option.pricing.purchaseOptions[termKey]
  });
  return {
    content,
    primaryProductApiName,
    currencyCode,
    paymentTerm,
    commitmentTerm,
    purchaseRequest: {
      products: requestedProducts,
      quantityPacks: [],
      currencyCode,
      commitmentTerm,
      paymentTerm
    },
    purchaseMotions: ((_option$purchaseMotio = option.purchaseMotionsByTerm[termKey]) !== null && _option$purchaseMotio !== void 0 ? _option$purchaseMotio : []).filter(isPublicPurchaseMotion)
  };
}
export function buildFscCheckoutCtas(details, disabled) {
  const {
    primaryProductApiName,
    purchaseRequest,
    purchaseMotions,
    currencyCode,
    paymentTerm,
    commitmentTerm
  } = details;
  return purchaseMotions.map((purchaseMotion, displayIndex) => ({
    purchaseMotion,
    productApiName: primaryProductApiName,
    displayIndex,
    disabled,
    uiButtonProps: {
      marginInlineStart: '0'
    },
    currencyCode,
    paymentTerm,
    commitmentTerm,
    nonMerchandiseIdIdentifier: TRACKING_SOURCES.FSC_CONFIGURE,
    trackingData: {
      app: TRACKING_SOURCES.PRICING_PAGES,
      source: TRACKING_SOURCES.FSC_CONFIGURE,
      screen: Screens.FSC_CONFIGURE,
      uniqueId: `${TRACKING_SOURCES.FSC_CONFIGURE}-${primaryProductApiName}`
    },
    purchaseRequest: purchaseMotion === 'BUY_TOUCHLESS' ? purchaseRequest : undefined
  }));
}